module.exports = __webpack_public_path__ + "img/23.9822c477.jpeg";